import axios from 'axios';

// Track if we've already fetched the CSRF token
let csrfTokenFetched = false;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get XSRF token from cookie
    const token = document.cookie
      .split('; ')
      .find(row => row.startsWith('XSRF-TOKEN='))
      ?.split('=')[1];
    
    if (token) {
      const decodedToken = decodeURIComponent(token);
      config.headers['X-XSRF-TOKEN'] = decodedToken;
      
      // Add debug logging to track token usage
      if (process.env.NODE_ENV !== 'production') {
        console.debug(`Using CSRF token for ${config.url}: ${decodedToken.substring(0, 10)}...`);
      }
    } else {
      console.log('No XSRF-TOKEN cookie found');
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Check if this response contains a new XSRF token in Set-Cookie header
    const setCookieHeader = response.headers['set-cookie'];
    if (setCookieHeader && setCookieHeader.find(cookie => cookie.includes('XSRF-TOKEN'))) {
      console.debug('New CSRF token received from server');
    }
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      // window.location.href = '/account';
    }
    return Promise.reject(error);
  }
);

/**
 * Ensures the CSRF token is fetched once per session
 * Use this function before making API calls that require CSRF protection
 * @returns {Promise} A promise that resolves when the CSRF token is ready
 */
export const ensureCsrfToken = async () => {
  if (!csrfTokenFetched) {
    try {
      await axiosInstance.get('/sanctum/csrf-cookie');
      // Small delay to ensure cookie is set
      await new Promise(resolve => setTimeout(resolve, 100));
      csrfTokenFetched = true;
      return true;
    } catch (error) {
      console.error('Failed to fetch CSRF token:', error);
      return false;
    }
  }
  return true;
};

export default axiosInstance;
